
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { CompanyModel } from './Entities.GormCrm.Company';
import { Model, ModelProperty } from 'models/Model';


export class CompanyResponsibleModel extends Model<CompanyResponsibleModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyId', type: 'string' },
		{ name: 'userId', type: 'string' },
		{ name: 'role', type: 'number' },
		{ name: 'company', type: 'CompanyModel', isHidden: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } }
	];
	[key: string]: any;
	
	public companyId?: string;
	public userId?: string;
	public role: number;
	public company?: CompanyModel;
    
	constructor(){
		super();
		this.companyId = undefined;
		this.userId = undefined;
		this.role = 0;
		this.company = undefined;
		
	}
	getProperties(){
		return CompanyResponsibleModel.classProperties;
	}
}

